<template>
  <div :class="$style['tip-selection']" v-background-color="colorBackground">
    <section>
      <page-header
        :tableNumber="tableNumber"
        :colorFont="colorFontBody"
        :fontDetail="fontDetailBody"
        hasBackButton
        @back="$emit('back')"
      >
        <page-indicator
          :colorPrimary="colorPrimary"
          :colorSecondary="colorSecondary"
          :index="1"
        />
      </page-header>
    </section>
    <section :class="$style['intro']">
      <h1
        v-if="tipTitle"
        v-color="colorFontHeading"
        v-font-style="fontDetailHeading"
        v-text="tipTitle"
      />
      <p
        v-if="tipBodyText"
        v-color="colorFontBody"
        v-font-style="fontDetailBody"
        v-text="tipBodyText"
      />
    </section>
    <section :class="$style['inputs']" class="tip-selection__input-container">
      <div :class="$style['buttons']">
        <v-button
          buttonText="10%"
          :colorButton="colorSecondary"
          :colorButtonText="colorFontButton"
          :fontButton="fontDetailButton"
          :tipAmount="getPercentageOfTotal(0.1)"
          @buttonClick="handleTipSelection('10%', getPercentageOfTotal(0.1))"
          :selected="selected === '10%'"
          :colorSelected="colorPrimary"
        />
        <v-button
          buttonText="12.5%"
          :colorButton="colorSecondary"
          :colorButtonText="colorFontButton"
          :fontButton="fontDetailButton"
          :tipAmount="getPercentageOfTotal(0.125)"
          @buttonClick="
            handleTipSelection('12.5%', getPercentageOfTotal(0.125))
          "
          :selected="selected === '12.5%'"
          :colorSelected="colorPrimary"
        />
        <v-button
          buttonText="15%"
          :colorButton="colorSecondary"
          :colorButtonText="colorFontButton"
          :fontButton="fontDetailButton"
          :tipAmount="getPercentageOfTotal(0.15)"
          @buttonClick="handleTipSelection('15%', getPercentageOfTotal(0.15))"
          :selected="selected === '15%'"
          :colorSelected="colorPrimary"
        />
      </div>
      <v-input-money
        ref="input"
        label="Or add a custom tip amount:"
        placeholder="Enter tip amount"
        withCurrency="£"
        :colorFont="colorFontBody"
        :fontDetail="fontDetailBody"
        @input="handleInput"
        @formSubmit="handleContinue"
      />
      <p
        v-if="tipDeclineText"
        :class="$style['decline']"
        v-text="tipDeclineText"
        v-color="colorFontBody"
        v-font-style="fontDetailBody"
        @click="handleContinue(0)"
      />
    </section>
    <section :class="$style['footer']" v-background-color="colorBackground">
      <v-button
        hasContainer
        :colorButton="colorPrimary"
        :colorButtonText="colorFontButton"
        :disabled="!canProceed"
        :buttonText="tipButtonText"
        :fontButton="fontDetailButton"
        @buttonClick="handleContinue"
      />
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import PageHeader from '@components/page-header.vue'
import PageIndicator from '@components/page-indicator.vue'

const VButton = () => import('@components/v-button.vue')
const VInputMoney = () => import('@components/v-input-money.vue')

export default {
  components: {
    PageHeader,
    PageIndicator,
    VButton,
    VInputMoney,
  },
  data: () => ({
    input: null,
    selected: null,
  }),
  computed: {
    ...mapGetters('contentful', [
      'colorBackground',
      'colorPrimary',
      'colorSecondary',
      'colorFontBody',
      'colorFontButton',
      'colorFontHeading',
      'fontDetailBody',
      'fontDetailButton',
      'fontDetailHeading',
      'tipBodyText',
      'tipButtonText',
      'tipDeclineText',
      'tipTitle',
    ]),
    ...mapGetters('payment', ['tableNumber', 'totalIncludingDiscount']),
    canProceed() {
      return (this.input && this.input >= 0) || this.selected
    },
  },
  methods: {
    handleInput(input) {
      this.selected = null
      this.input = input
      this.$emit('handleTipSelection', { input })
    },
    handleTipSelection(id, percentage) {
      this.input = null
      this.$refs.input.input = null

      Vue.nextTick(() => {
        if (id === this.selected) {
          this.selected = null
        } else {
          this.selected = id
        }

        this.$emit('handleTipSelection', { percentage })
      })
    },
    handleContinue(percentage) {
      if (percentage === 0) {
        this.input = null
        this.$emit('handleTipSelection', { clear: true })
      }
      this.$emit('handleContinue', { input: this.input, percentage })
    },
    getPercentageOfTotal(percentage) {
      return parseFloat(this.totalIncludingDiscount * percentage).toFixed(2)
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.tip-selection {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  width: 100%;

  .intro,
  .inputs {
    padding: 16px 16px 0;
  }

  .inputs {
    padding-top: 40px;
    padding-bottom: 68px;
  }

  &__container {
    padding: 0 16px;

    p {
      font-size: 14px;
    }
  }

  &__input-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    padding: 20px 16px;
  }

  &__content {
    margin: 0 16px 170px;
  }

  .buttons {
    display: flex;

    div {
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__input {
    input {
      border-radius: 0;
      font-size: 16px;
      height: 100%;
      padding: 12px;
      text-align: center;
      width: 100%;
    }
  }

  .decline {
    font-size: 14px;
    margin-top: 12px;
    text-decoration: underline;
  }

  .footer {
    bottom: 0;
    left: 0;
    position: fixed;
    text-align: center;
    width: 100%;
  }
}
</style>
